import React, { useState, useContext } from "react";
import { useMutation } from "react-query";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { learners } from "../../../../../../api/learners"; 
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = ({setOpenResetModal}) => {

  const { mutateAsync } = useMutation(learners.ResetPassword);
  const currentLearner = JSON.parse(sessionStorage.getItem("currentLearner"));
  const [showPassword, setShowPassword] = useState(false);

  const initialValues = {
    otp: "",
    password: "",
  };

  const validationSchema = Yup.object({
    otp: Yup.string().required("OTP is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
  });

  const onSubmit = async (values) => {
    toast.loading("Resetting password...");
    const payload = {
      ...values,
      email: currentLearner?.participant?.user?.email,
      isAdmin: true,
    };
    try {
      const data = await mutateAsync(payload);
      toast.remove();
      toast.success(data?.message);
      setTimeout(() => {
        setOpenResetModal(false);
      }, 500);
    } catch (error) {
      toast.remove();
      toast.error(error?.data?.message);
    }
  };

  return (
    <div className="text-left">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {() => (
          <Form className="w-full mx-auto p-4 bg-white rounded-md">
            <div className="mb-4">
              <label htmlFor="otp" className="text-gray-700 w-full text-sm font-medium text-left mb-2">
                OTP
              </label>
              <Field
                id="otp"
                name="otp"
                type="text"
                className="appearance-none text-xs border rounded w-full p-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter OTP"
              />
              <ErrorMessage name="otp" component="div" className="text-red-500 text-xs mt-1" />
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="text-gray-700 text-sm font-medium text-left mb-2">
                Password
              </label>
              <div className="relative">
                <Field
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  className="appearance-none text-xs border rounded w-full p-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Enter Password"
                />
                <button
                  type="button"
                  className="absolute -mt-3 inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <ErrorMessage name="password" component="div" className="text-red-500 text-xs mt-1" />
            </div>

            <div className="flex items-center justify-between">
              <button
                type="submit"
                className="bg-darkBlue text-white font-medium text-sm py-2 px-4 rounded w-full"
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;